import { render, staticRenderFns } from "./RealIntentionRegisterOrEdit.vue?vue&type=template&id=362939c8"
import script from "./RealIntentionRegisterOrEdit.vue?vue&type=script&lang=js"
export * from "./RealIntentionRegisterOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports